import {
  //
  GET_PRE_TEMPLATE,
  GET_PRE_TEMPLATE_FAILURE,
  GET_PRE_TEMPLATE_SUCCESS,
  //
  SAVE_PRE_TEMPLATE,
  SAVE_PRE_TEMPLATE_FAILURE,
  SAVE_PRE_TEMPLATE_SUCCESS,
  //
  GET_ASSESSMENTS,
  GET_ASSESSMENTS_FAILURE,
  GET_ASSESSMENTS_SUCCESS,
  //
  TOGGLE_HISTORY_MODAL,
  //
  GET_PRE_HISTORY,
  GET_PRE_HISTORY_FAILURE,
  GET_PRE_HISTORY_SUCCESS,
  //
  REFRESH_CODE,
  REFRESH_CODE_FAILURE,
  REFRESH_CODE_SUCCESS,
  //
  VERIFY_PIN,
  VERIFY_PIN_FAILURE,
  VERIFY_PIN_SUCCESS,
  //
  UPLOAD_DOC,
  UPLOAD_DOC_FAILURE,
  UPLOAD_DOC_SUCCESS,
  //
  SAVE_ASSESSMENT,
  SAVE_ASSESSMENT_FAILURE,
  SAVE_ASSESSMENT_SUCCESS,
  //
  GET_ASSESSMENT,
  GET_ASSESSMENT_FAILURE,
  GET_ASSESSMENT_SUCCESS,
  //
  UPDATE_PRE_STATUS,
  UPDATE_PRE_STATUS_FAILURE,
  UPDATE_PRE_STATUS_SUCCESS,
  //
  GET_UPLOADED_DOCS,
  GET_UPLOADED_DOCS_FAILURE,
  GET_UPLOADED_DOCS_SUCCESS,
  //
  GET_VIEW_ASSESSMENT,
  GET_VIEW_ASSESSMENT_FAILURE,
  GET_VIEW_ASSESSMENT_SUCCESS,
  //
  REPROCESS_DOC,
  REPROCESS_DOC_FAILURE,
  REPROCESS_DOC_SUCCESS,
} from "./constants";

export const getPreTemplate = (payload, onGet) => ({
  type: GET_PRE_TEMPLATE,
  payload,
  onGet,
});
export const getPreTemplateSuccess = (payload) => ({
  type: GET_PRE_TEMPLATE_SUCCESS,
  payload,
});
export const getPreTemplateFailure = (payload) => ({
  type: GET_PRE_TEMPLATE_FAILURE,
  payload,
});

export const savePreTemplate = (payload, onSave) => ({
  type: SAVE_PRE_TEMPLATE,
  payload,
  onSave,
});
export const savePreTemplateSuccess = (payload) => ({
  type: SAVE_PRE_TEMPLATE_SUCCESS,
  payload,
});
export const savePreTemplateFailure = (payload) => ({
  type: SAVE_PRE_TEMPLATE_FAILURE,
  payload,
});

// GET ASSESSMENTS
export const getAssessments = (payload, onGet) => ({
  type: GET_ASSESSMENTS,
  payload,
  onGet,
});
export const getAssessmentsSuccess = (payload) => ({
  type: GET_ASSESSMENTS_SUCCESS,
  payload,
});
export const getAssessmentsFailure = (payload) => ({
  type: GET_ASSESSMENTS_FAILURE,
  payload,
});

// TOGGLE HISTORY MODAL
export const toggleHistoryModal = (payload) => ({
  type: TOGGLE_HISTORY_MODAL,
  payload,
});

// GET PRE HISTORY
export const getPreHistory = (payload, onGet) => ({
  type: GET_PRE_HISTORY,
  payload,
  onGet,
});
export const getPreHistorySuccess = (payload) => ({
  type: GET_PRE_HISTORY_SUCCESS,
  payload,
});
export const getPreHistoryFailure = (payload) => ({
  type: GET_PRE_HISTORY_FAILURE,
  payload,
});

// REFRESH CODE
export const refreshCode = (payload, onRefresh) => ({
  type: REFRESH_CODE,
  payload,
  onRefresh,
});
export const refreshCodeSuccess = (payload) => ({
  type: REFRESH_CODE_SUCCESS,
  payload,
});
export const refreshCodeFailure = (payload) => ({
  type: REFRESH_CODE_FAILURE,
  payload,
});

// VERIFY PIN
export const verifyPin = (payload, onVerify) => ({
  type: VERIFY_PIN,
  payload,
  onVerify,
});
export const verifyPinSuccess = (payload) => ({
  type: VERIFY_PIN_SUCCESS,
  payload,
});
export const verifyPinFailure = (payload) => ({
  type: VERIFY_PIN_FAILURE,
  payload,
});

// UPLOAD DOC
export const uploadDoc = (payload, onUpload) => ({
  type: UPLOAD_DOC,
  payload,
  onUpload,
});
export const uploadDocSuccess = (payload) => ({
  type: UPLOAD_DOC_SUCCESS,
  payload,
});
export const uploadDocFailure = (payload) => ({
  type: UPLOAD_DOC_FAILURE,
  payload,
});

// CREATE ASSESSMENT
export const saveAssessment = (payload, onCreate) => ({
  type: SAVE_ASSESSMENT,
  payload,
  onCreate,
});
export const saveAssessmentSuccess = (payload) => ({
  type: SAVE_ASSESSMENT_SUCCESS,
  payload,
});
export const saveAssessmentFailure = (payload) => ({
  type: SAVE_ASSESSMENT_FAILURE,
  payload,
});

// GET ASSESSMENT
export const getAssessment = (payload, onGet) => ({
  type: GET_ASSESSMENT,
  payload,
  onGet,
});
export const getAssessmentSuccess = (payload) => ({
  type: GET_ASSESSMENT_SUCCESS,
  payload,
});
export const getAssessmentFailure = (payload) => ({
  type: GET_ASSESSMENT_FAILURE,
  payload,
});

// UPDATE PRE STATUS
export const updatePreStatus = (payload, onUpdate) => ({
  type: UPDATE_PRE_STATUS,
  payload,
  onUpdate,
});
export const updatePreStatusSuccess = (payload) => ({
  type: UPDATE_PRE_STATUS_SUCCESS,
  payload,
});
export const updatePreStatusFailure = (payload) => ({
  type: UPDATE_PRE_STATUS_FAILURE,
  payload,
});

// GET UPLOADED DOCS
export const getUploadedDocs = (payload, onGet) => ({
  type: GET_UPLOADED_DOCS,
  payload,
  onGet,
});
export const getUploadedDocsSuccess = (payload) => ({
  type: GET_UPLOADED_DOCS_SUCCESS,
  payload,
});
export const getUploadedDocsFailure = (payload) => ({
  type: GET_UPLOADED_DOCS_FAILURE,
  payload,
});

// GET VIEW ASSESSMENT
export const getViewAssessment = (payload, onGet) => ({
  type: GET_VIEW_ASSESSMENT,
  payload,
  onGet,
});
export const getViewAssessmentSuccess = (payload) => ({
  type: GET_VIEW_ASSESSMENT_SUCCESS,
  payload,
});
export const getViewAssessmentFailure = (payload) => ({
  type: GET_VIEW_ASSESSMENT_FAILURE,
  payload,
});

// REPROCESS DOC
export const reprocessDoc = (payload, onReprocess) => ({
  type: REPROCESS_DOC,
  payload,
  onReprocess,
});
export const reprocessDocSuccess = (payload) => ({
  type: REPROCESS_DOC_SUCCESS,
  payload,
});
export const reprocessDocFailure = (payload) => ({
  type: REPROCESS_DOC_FAILURE,
  payload,
});
